module.exports = __webpack_public_path__ + "files/e6c774663aba0ba246dc4784fa92ca23.png";